module.exports = __webpack_public_path__ + "static/media/wab32_1020.8054148a.ico";